import { Injectable } from '@angular/core';

declare global {
  interface Window {
    fbq?: (...args: any[]) => void;
  }
}

@Injectable({
  providedIn: 'root'
})
export class MetaService {
  private get hasFbq(): boolean {
    return typeof window !== 'undefined' && typeof window.fbq === 'function';
  }

  trackStandard(eventName: string, params?: Record<string, any>): void {
    if (!this.hasFbq) { return; }
    window.fbq!('track', eventName, params || {});
  }

  trackCustom(eventName: string, params?: Record<string, any>): void {
    if (!this.hasFbq) { return; }
    window.fbq!('trackCustom', eventName, params || {});
  }
}
